<template>
	<v-container style="position: relative !important;" v-if="selectedPlace">
		<!-- form notificacions -->
		<notifications-form :placeId="selectedPlace.value" />
		<notifications-table :placeId="selectedPlace.value" />
		<v-row no-gutters>
			<v-col cols="12" class="subtitle-2 secondary--text text-left" v-if="verifyDates">
				{{ verifyDates }}
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12" sm="4" lg="3">
				<v-menu
					ref="menuDate1"
					v-model="menuDate1"
					:close-on-content-click="false"
					:return-value.sync="date1"
					transition="scale-transition"
					offset-y
					min-width="290px"
				>
					<template v-slot:activator="{ on }">
						<v-text-field
							solo
							v-model="date1"
							dense
							outlined
							filled
							readonly
							small
							:label="$vuetify.breakpoint.lgAndUp ? 'Fecha inicio' : 'Inicio'"
							hide-details
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker v-model="date1" outlined locale="es" no-title scrollable>
						<v-spacer></v-spacer>
						<v-btn text color="primary" @click="menuDate1 = false">Cancelar</v-btn>
						<v-btn text color="primary" @click="$refs.menuDate1.save(date1)">OK</v-btn>
					</v-date-picker>
				</v-menu>
			</v-col>
			<v-col cols="12" sm="4" lg="3">
				<v-menu
					ref="menuDate2"
					v-model="menuDate2"
					:close-on-content-click="false"
					:return-value.sync="date2"
					transition="scale-transition"
					offset-y
					min-width="290px"
				>
					<template v-slot:activator="{ on }">
						<v-text-field
							solo
							v-model="date2"
							dense
							outlined
							filled
							readonly
							small
							:label="$vuetify.breakpoint.lgAndUp ? 'Fecha fin' : 'Fin'"
							hide-details
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker v-model="date2" outlined locale="es" no-title scrollable>
						<v-spacer></v-spacer>
						<v-btn text color="primary" @click="menuDate2 = false">Cancelar</v-btn>
						<v-btn text color="primary" @click="$refs.menuDate2.save(date2)">OK</v-btn>
					</v-date-picker>
				</v-menu>
			</v-col>
			<v-col cols="12" sm="4" lg="3">
				<v-btn block color="primary" v-if="!verifyDates" @click="cancelFilter">
					Cancelar
				</v-btn>
			</v-col>
		</v-row>
		<v-data-table
			mobile-breakpoint="300"
			class="backgroundTransparent"
			loading-text="Buscando notificaciones... Por favor espere"
			:loading="loading"
			:headers="headers"
			:items="listNotifications"
			:search="search"
			:items-per-page="5"
			no-data-text="Sin notificaciones"
			:footer-props="{
				'items-per-page-text': 'Notificaciones por página',
			}"
		>
			<template v-slot:[`item.date_time`]="{ item }">
				{{ item.date_time | dateTimeFormat }}
			</template>
			<template v-slot:[`item.fullName`]="{ item }">
				{{ item.firstName }} {{ item.lastName }}
			</template>
			<template v-slot:[`item.phone`]="{ item }">
				{{ item.phone ? item.phone : 'Sin número' }}
			</template>
			<template v-slot:[`item.start_end`]="{ item }">
				{{ item.activity_start | dateFormat }} <span>al</span>
				{{ item.activity_end | dateFormat }}
			</template>
			<template v-slot:[`item.state`]="{ item }">
				<template v-if="item.notify_type === 'sms' || item.notify_type === 'gps'">
					<v-select
						:item-color="getColor(item.state)"
						:prepend-inner-icon="
							item.notify_type == 'gps'
								? 'mdi-map-marker-check-outline'
								: 'mdi-message-text-outline'
						"
						v-model="item.state"
						item-text="userText"
						item-value="state"
						:items="getNotifyState"
						@change="changeState(item, item.state)"
					>
					</v-select>
				</template>
				<template v-else>
					{{ getStateName(item.state) }}
				</template>
			</template>
		</v-data-table>
	</v-container>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
	name: 'Notifications',
	components: {
		NotificationsTable: () => import('@/components/notifications/NotificationsTable'),
		NotificationsForm: () => import('@/components/notifications/NotificationsForm'),
	},
	filters: {
		dateFormat: dateTime => {
			return moment(dateTime).format('DD-MM-YYYY');
		},
		dateTimeFormat: dateTime => {
			return moment(dateTime).format('DD-MM-YYYY HH:mm');
		},
	},
	data() {
		return {
			date1: null,
			date2: null,
			menuDate1: false,
			menuDate2: false,
			loading: false,
			search: '',
			headers: [
				{ text: 'Día y hora', value: 'date_time', align: 'left', sortable: false },
				{
					text: 'Tipo de notificación',
					value: 'message',
					align: 'left',
					sortable: false,
				},
				{ text: 'Destinatario', value: 'fullName', align: 'left', sortable: false },
				{ text: 'Teléfono', value: 'phone', align: 'left', sortable: false },
				{
					text: 'Inicio y fin de actividad',
					value: 'start_end',
					align: 'left',
					sortable: false,
				},
				{ text: 'Estado', value: 'state', align: 'left', width: '15%', sortable: false },
			],
		};
	},
	computed: {
		notification() {
			let temp = [];
			this.lodgings.forEach(lod => {
				this.persons.forEach(person => {
					const personId = person._id;
					if (personId === lod.person) {
						if (!lod.userNotifications) return true;
						lod.userNotifications.forEach(notify => {
							const notifySave = {
								lodgingId: lod._id,
								notiId: notify._id,
								date_time: notify.date,
								message: notify.type,
								notify_type: notify.type,
								lastName: person.lastName,
								firstName: person.firstName,
								phone: person.phone,
								activity_start: lod.start,
								activity_end: lod.end,
								state: notify.state,
							};
							temp.push(notifySave);
						});
					}
				});
			});
			return temp;
		},
		listNotifications() {
			if (!this.verifyDates) {
				return this.notification.filter(item => {
					if (
						moment(item.date_time).isSameOrAfter(this.date1) &&
						moment(item.date_time).isSameOrBefore(this.date2)
					)
						return true;
					else return false;
				});
			}
			const notification = [...this.notification].sort();
			return notification;
		},
		verifyDates() {
			if (this.date1 && this.date2)
				return moment(this.date1).isSameOrAfter(moment(this.date2))
					? 'La fecha de inicio debe ser anterior a la final'
					: false;
			else return 'Selecione una fecha inicio y fin para filtrar';
		},
		...mapGetters({
			getNotifyState: 'Lodging/getNotifyState',
			lodgings: 'Lodging/lodgings',
			persons: 'Person/persons',
			selectedPlace: 'Lodging/selectedPlace',
		}),
	},
	methods: {
		getColor(state) {
			switch (state) {
				case 0:
					return '';
				case 1:
					return 'success';
				case 2:
					return 'error';
				case 3:
					return 'warning';
				case 4:
					return 'info';
				default:
					break;
			}
		},
		cancelFilter() {
			this.date1 = null;
			this.date2 = null;
		},
		getStateName(state) {
			return this.getNotifyState[state].userText;
		},
		async changeState(item, newState) {
			const lodgingId = item.lodgingId;
			const notiId = item.notiId;
			try {
				this.updateNotification({ lodgingId, notiId, newState });
				this.snackbar({
					content: 'Estado cambiado exitosamente',
					color: 'success',
				});
			} catch (e) {
				this.snackbar({
					content: e.message,
					color: 'error',
				});
			}
		},
		...mapActions({ updateNotification: 'Lodging/updateNotification' }),
		...mapMutations({ snackbar: 'Snackbar/showMessage' }),
	},
};
</script>
